import { render } from "./App.vue?vue&type=template&id=b56ec9e2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b56ec9e2&lang=scss"

import exportComponent from "/Users/zsrb/Documents/中山日报/2025/zsrb-news-detail/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__